import { AxiosResponse } from 'axios';
import axiosInstance from '../../module/axios.module';

export interface IParcelaAtrasada {
  numVenda: number;
  idEmpreendimento: number;
  nomeEmpreendimento: string;
  numUnidade: string;
  numSubUnidade: string;
  valorOriginal: number;
  valorAtual: number;
  valorDevido: number;
  percentualDesconto: number;
  percentualMaster: number;
  valorBaixado: number;
  valorProposta: number;
  valorDesconto: number;
  valorJuros: number;
  valorSeguro: number;
  valorMulta: number;
  valorCorrecaoMonetaria: number;
  valorJurosContratuais: number;
  valorDescontoDescaptalizacao: number;
  mesVencimento: number;
  idBaixa: number;
  dataVencimento: string;
  dataPagamento: string | null;
  dataEntrega: string | null;
  status: number;
  idlan: number;
  codcoligada: number;
  numParcela: string;
  taxajuros: number;
  temPrice: boolean;
}

interface IBuscaParcelaAtrasadaResponse {
  Success: boolean;
  Message: string;
  Data: IParcelaAtrasada[];
  Total: number;
  Timestamp: string;
}

export default async function BuscaParcelaAtrasadaRM(
  numVenda: number,
  codcoligada: string,
  access_token: string,
): Promise<IParcelaAtrasada[]> {
  try {
    const url = `Proposta/BuscaParcelaAtrasadaRM?_numVenda=${numVenda}&_codcoligada=${codcoligada}`;

    const response: AxiosResponse<IBuscaParcelaAtrasadaResponse> =
      await axiosInstance.get(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });

    return response.data.Data;
  } catch (e) {
    return [];
  }
}
